import { useEffect, useState } from 'react'
import { NavLink, Outlet, Link, useNavigate } from 'react-router-dom'
import { TOKEN_KEYS, getToken } from './api'

const NAV = [
  { items: [{ to: '/admin', label: 'Reports', end: true }, { to: '/admin/overview', label: 'Overview', end: true }] },
  { group: 'Catalog', items: [{ to: '/admin/products', label: 'Products' }, { to: '/admin/categories', label: 'Categories' }] },
  { group: 'Sales', items: [{ to: '/admin/orders', label: 'Orders' }, { to: '/admin/coupons', label: 'Coupons' }, { to: '/admin/customers', label: 'Customers' }, { to: '/admin/reviews', label: 'Reviews' }] },
  { group: 'Storefront', items: [{ to: '/admin/header', label: 'Header' }, { to: '/admin/banners', label: 'Banners' }, { to: '/admin/about', label: 'About us Page' }, { to: '/admin/contact', label: 'Contact-us Page' }, { to: '/admin/footer', label: 'Footer' }] },
]

export default function AdminLayout() {
  const [open, setOpen] = useState(false)
  const navigate = useNavigate()
  const signedIn = !!getToken()

  /* While the mobile menu is open: lock page scroll, close on Escape,
     and close automatically if the window is resized to desktop width. */
  useEffect(() => {
    if (!open) return
    const onKey = (e) => {
      if (e.key === 'Escape') setOpen(false)
    }
    const mq = window.matchMedia('(min-width: 861px)')
    const onChange = (e) => {
      if (e.matches) setOpen(false)
    }
    document.addEventListener('keydown', onKey)
    mq.addEventListener('change', onChange)
    document.body.style.overflow = 'hidden'
    return () => {
      document.removeEventListener('keydown', onKey)
      mq.removeEventListener('change', onChange)
      document.body.style.overflow = ''
    }
  }, [open])

  if (!signedIn) {
    return (
      <div className="adm adm-solo">
        <div className="state">
          <strong>Sign in to open the admin dashboard</strong>
          <p className="muted">Your session token was not found.</p>
          <Link className="btn primary" to="/login">Go to sign in</Link>
        </div>
      </div>
    )
  }

  const logout = () => {
    TOKEN_KEYS.forEach((k) => localStorage.removeItem(k))
    navigate('/login')
  }

  return (
    <div className="adm">
      <button className="menu-btn" onClick={() => setOpen(true)} aria-label="Open menu" aria-expanded={open}>
        ☰ Menu
      </button>
      {open && <div className="scrim" onClick={() => setOpen(false)} />}

      <aside className={`side${open ? ' open' : ''}`} aria-label="Admin navigation">
        <div className="brand-row">
          <div className="brand">Store admin</div>
          <button className="side-close" onClick={() => setOpen(false)} aria-label="Close menu">✕</button>
        </div>

        <nav>
          {NAV.map((g, i) => (
            <div key={i} className="nav-group">
              {g.group && <div className="nav-title">{g.group}</div>}
              {g.items.map((n) => (
                <NavLink
                  key={n.to}
                  to={n.to}
                  end={n.end}
                  onClick={() => setOpen(false)}
                  className={({ isActive }) => `nav-link${isActive ? ' active' : ''}`}
                >
                  {n.label}
                </NavLink>
              ))}
            </div>
          ))}
        </nav>

        <div className="side-foot">
          <Link to="/" className="nav-link">View store</Link>
          <button className="nav-link" onClick={logout}>Sign out</button>
        </div>
      </aside>

      <main className="main"><Outlet /></main>
    </div>
  )
}
